module.exports = __webpack_public_path__ + "static/media/Mask Group-3.fb2733bd.png";